import { createPageSegmentLoadMetric } from '../../metricConfigs.ts';
import { APP_NAVIGATION_SEGMENT_KEY } from '../../metric-keys/index.ts';

export const APP_NAVIGATION_METRIC = createPageSegmentLoadMetric({
	key: APP_NAVIGATION_SEGMENT_KEY,
	ssr: Boolean(window.__SSR_RENDERED__) ? { doneAsFmp: true } : undefined,
});
